module.exports = __webpack_public_path__ + "img/extra.baefb041.svg";